import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import SeoHead from "@/components/site/SeoHead";
import { COMPANY } from "@/data/content";

export default function LegalLayout({ title, description, children }) {
  return (
    <>
      <SeoHead title={`${title} | ${COMPANY.name}`} description={description} canonical={COMPANY.domain} noindex />
      <Header />
      <main className="bg-secondary">
        <div className="container-x py-12 sm:py-16">
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--brand-navy)] hover:text-[color:var(--brand-green-alt)]">
            <ArrowLeft className="h-4 w-4" /> Zurück zur Startseite
          </Link>
          <div className="mt-6 rounded-3xl border border-border bg-white p-6 sm:p-10 card-shadow">
            <h1 className="font-display text-4xl sm:text-5xl text-[color:var(--brand-navy)]">{title}</h1>
            <div className="mt-6 legal-content space-y-4 text-[15px] leading-relaxed text-muted-foreground">
              {children}
            </div>
            <div className="mt-10 pt-6 border-t border-border flex items-center gap-3">
              <Phone className="h-5 w-5 text-[color:var(--brand-green-alt)]" />
              <span className="text-sm font-semibold text-[color:var(--brand-navy)]">Fragen? Rufen Sie uns an: <a href={`tel:${COMPANY.phoneHref}`} className="underline">{COMPANY.phoneDisplay}</a></span>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export function H2({ children }) {
  return <h2 className="text-xl font-bold text-[color:var(--brand-navy)] pt-4">{children}</h2>;
}
